import * as types from './showSeasonActionTypes';

export const getShowSeason = () => ({
  type: types.GET_SHOW_SEASON_REQUEST,
});

export const setShowApplicants = applicants => ({
  type: types.SET_SHOW_APPLICANTS,
  applicants,
});

export const submitApplicants = applicants => ({
  type: types.SUBMIT_APPLICANTS_REQUEST,
  applicants,
});



// WEBPACK FOOTER //
// ./src/store/showSeason/showSeasonActions.js